import { Col, Image, Row, Typography, message, Button } from "antd";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  selectIsUpdateWorkOffers,
  selectWorkOffersForUpdate,
} from "../../../../redux";

import { IDataForUpdateWorkOffers } from "../../../../redux/@types";
import {
  AdminMenuLayout,
  InputHTML,
  InputNumber,
  InputSelect,
  InputText,
} from "../../../../shared/components";
import Upload from "../../../../shared/components/ui/inputs/Upload";
import { PATH_S3_BUCKET } from "../../../../shared/utils/constants";
import { useWorkOffers, useWorkOffersById } from "../../hook";
import { WrapperCardWorkOffers } from "../styled";

const { Title } = Typography;

export const WorkOffersById = () => {
  const isUpdateWorkOffers = useSelector(selectIsUpdateWorkOffers);
  const updateWorkOffers = useSelector(selectWorkOffersForUpdate);
  const { isLoading, onSubmitCreateOrUpdate } = useWorkOffers();
  const { arrCategories, arrCities, isValidate } = useWorkOffersById();
  const {
    control,
    handleSubmit: onSubmit,
    setValue,
    watch,
  } = useFormContext<IDataForUpdateWorkOffers>();

  const pathCover = watch("path_cover");
  return (
    <AdminMenuLayout pageDescription="WorkOffersById" title="WorkOffersById">
      <WrapperCardWorkOffers>
        {isValidate && (
          <Row
            gutter={[8, 8]}
            style={{
              padding: "10px",
              width: "100%",
            }}
          >
            <Col
              span={24}
              style={{
                width: "100%",
                display: "flex",
                // padding: 5,
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "row",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "var(--primary)",
                  marginRight: 7,
                }}
                level={2}
              >
                {isUpdateWorkOffers
                  ? `Actualizando oferta de trabajo: '${updateWorkOffers?.id!}'`
                  : `Creando oferta de trabajo`}
              </Title>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Imagen:
              </Title>
              {pathCover ? (
                <img
                  src={`${PATH_S3_BUCKET}/${pathCover}`}
                  alt="path_cover"
                  style={{
                    marginBottom: "7px",
                    width: "100%",
                    height: "100%",
                    maxWidth: "250px",
                    maxHeight: "250px",
                  }}
                />
              ) : (
                <img
                  style={{
                    marginBottom: "7px",
                    maxWidth: "250px",
                    maxHeight: "250px",
                  }}
                  alt="error"
                  src="data:image/png;base64,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"
                />
              )}
              <Upload
                filePath="path_cover"
                onUploadedFile={(files) => {
                  // console.log({ files });
                  const file = files[0];
                  setValue("path_cover", file.fileKey);
                  message.success("Se ha actualizado la imagen");
                }}
              />
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Categoría:
              </Title>
              <InputSelect
                showSearch
                name="category_id"
                control={control}
                dataOptions={
                  arrCategories?.map((item) => ({
                    value: item.id.toString(),
                    title: item.name,
                  })) || []
                }
                label="Categoria"
              />
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Ciudad:
              </Title>
              <InputSelect
                showSearch
                name="city_id"
                control={control}
                dataOptions={
                  arrCities?.map((item) => ({
                    value: item.id.toString(),
                    title: item.name,
                  })) || []
                }
                label="Ciudad"
              />
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Bacante:
              </Title>
              <InputText
                placeHolder="Manicurista"
                name="job"
                control={control}
              />
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Dirección:
              </Title>
              <InputText
                placeHolder="Calle 1 #2a - 3"
                name="address"
                control={control}
              />
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Nombre de la compañia:
              </Title>
              <InputText
                placeHolder="Casandra Team"
                name="company_name"
                control={control}
              />
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                marginTop: "10px",
                padding: 5,
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Salario:
              </Title>
              <InputNumber
                placeHolder="1500000"
                name="salary"
                control={control}
              />
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                marginTop: "10px",
                padding: 5,
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Tipo de trabajo:
              </Title>
              <InputSelect
                name="job_type"
                control={control}
                dataOptions={[
                  { title: "Tiempo Completo", value: "tiempo_completo" },
                  { title: "Medio Tiempo", value: "medio_tiempo" },
                  {
                    title: "Trabajo Independiente",
                    value: "trabajo_independiente",
                  },
                ]}
                label="Tipo de trabajo"
              />
            </Col>
            {isUpdateWorkOffers && (
              <Col
                span={8}
                style={{
                  display: "flex",
                  marginTop: "10px",
                  padding: 5,
                  justifyContent: "center",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <Title style={{ marginBottom: "1.5px" }} level={5}>
                  Estado:
                </Title>
                <InputSelect
                  name="status"
                  control={control}
                  dataOptions={[
                    { title: "Activo", value: "active" },
                    { title: "Inactivo", value: "inactive" },
                  ]}
                  label="Estado"
                />
              </Col>
            )}
            <Col
              span={24}
              style={{
                display: "flex",
                marginTop: "10px",
                padding: 5,
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "7.5px" }} level={5}>
                Descripción:
              </Title>
              {isUpdateWorkOffers ? (
                <InputHTML
                  placeHolder="El trabajo requiere de soltura en los campos de...."
                  name="description"
                  control={control}
                  isUpdating
                />
              ) : (
                <InputHTML
                  placeHolder="El trabajo requiere de soltura en los campos de...."
                  name="description"
                  control={control}
                />
              )}
            </Col>
            <Col
              span={24}
              style={{
                display: "flex",
                marginTop: "10px",
                padding: 5,
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "7.5px" }} level={5}>
                Requerimientos:
              </Title>
              {isUpdateWorkOffers ? (
                <InputHTML
                  placeHolder="Poseer habilidades en...."
                  name="requirements"
                  control={control}
                  isUpdating
                />
              ) : (
                <InputHTML
                  placeHolder="Poseer habilidades en...."
                  name="requirements"
                  control={control}
                />
              )}
            </Col>
            <Col
              span={24}
              style={{
                display: "flex",
                marginTop: "10px",
                padding: 5,
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "7.5px" }} level={5}>
                Responsabilidades:
              </Title>
              {isUpdateWorkOffers ? (
                <InputHTML
                  placeHolder="Hacerse cargo de...."
                  name="responsibilities"
                  control={control}
                  isUpdating
                />
              ) : (
                <InputHTML
                  placeHolder="Hacerse cargo de...."
                  name="responsibilities"
                  control={control}
                />
              )}
            </Col>

            <Button
              style={{
                width: "100%",
                marginTop: 10,
              }}
              type="primary"
              shape="round"
              size="large"
              onClick={onSubmit(onSubmitCreateOrUpdate)}
              loading={isLoading}
            >
              {isUpdateWorkOffers
                ? "Actualizar información"
                : "Crear oferta de trabajo"}
            </Button>
          </Row>
        )}
      </WrapperCardWorkOffers>
    </AdminMenuLayout>
  );
};
